export default {
    init() {

      $(window).load(function() {
        $('.latestPosts').each(function(){  
        
          var highestBox = 0;
          
          $('article.post', this).each(function(){
            
            if($(this).height() > highestBox) {
              highestBox = $(this).height(); 
            }
          
          });  
    
          $('article.post',this).height(highestBox);
                        
        }); 
     
      });

    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/blog.js